<template>
  <div :class="$style['become-a-partners']">
    <div :class="$style['become-a-partners__back-btn']">
      <mds-button
        variation="flat"
        icon="caret-left"
        :to="HOME_URL + '/partners'"
      >Back to Partners</mds-button>
    </div>
    <mds-layout-grid class="mds-doc-typography___devsite" v-if="itemsData">
      <template>
        <mds-row>
          <mds-col cols="8">
            <h1 :class="$style['become-a-partners__title']">{{ itemsData.name }}</h1>
            <item-description :description="itemsData.description" :class="$style['become-a-partners__overview']"></item-description>
          </mds-col>
          <mds-col cols="3" :pull="1">
            <svg viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke-width='0.2'><path d="M23.8125 12.4614L22.4113 11.0299C21.0658 9.68431 19.3015 9.01252 17.5379 9.01454C16.481 9.01575 15.3931 8.76764 14.6458 8.02029L12.8406 6.21509M3 16.0557L4.80521 17.8608C5.55261 18.6081 5.80074 19.696 5.79954 20.753C5.79754 22.5166 6.46932 24.2808 7.81489 25.6263L9.37965 27.1911" stroke="black" stroke-linecap="round"/><path d="M38.6151 27.1646L40.1278 25.6519C41.461 24.3187 42.1327 22.5745 42.143 20.8271C42.149 19.807 42.388 18.7609 43.0966 18.027L45 16.0557M20.1872 16.3996L25.5313 11.0555C26.8665 9.72024 28.614 9.04848 30.364 9.04018C31.412 9.03521 32.4886 8.78475 33.2297 8.04369L35.1088 6.16455" stroke="black" stroke-linecap="round"/><path d="M27.6493 16.268L39.3361 27.9546C40.3438 28.9623 40.3438 30.5961 39.3361 31.6037C38.3284 32.6114 36.6947 32.6114 35.687 31.6037L32.5001 28.4168" stroke="black" stroke-linecap="round"/><path d="M29.3099 25.2268L35.6872 31.6041C36.6948 32.6117 36.6948 34.2455 35.6872 35.2532C34.6795 36.2608 33.0457 36.2608 32.038 35.2532L25.452 28.6672" stroke="black" stroke-linecap="round"/><path d="M25.3121 28.5273L32.0379 35.2531C33.0455 36.2608 33.0455 37.8946 32.0379 38.9022C31.0302 39.9099 29.3964 39.9099 28.3887 38.9022L27.47 37.9835" stroke="black" stroke-linecap="round"/><path d="M23.9734 41.7851L24.7396 42.5513C25.7473 43.559 27.3811 43.559 28.3887 42.5513C29.3964 41.5437 29.3964 39.9099 28.3887 38.9022L27.4975 38.011" stroke="black" stroke-linecap="round"/><path d="M21.4036 15.1829L17.7545 18.832C16.7468 19.8396 16.7468 21.4734 17.7545 22.4811C18.7621 23.4888 20.3959 23.4888 21.4036 22.4811L27.6326 16.2521" stroke="black" stroke-linecap="round"/><path d="M8.63179 31.604C7.62412 30.5964 7.62412 28.9626 8.63179 27.9549L12.2809 24.3058C13.2886 23.2981 14.9223 23.2981 15.93 24.3058C16.9377 25.3135 16.9377 26.9472 15.93 27.9549L12.2809 31.604C11.2732 32.6117 9.63947 32.6117 8.63179 31.604Z" stroke="black"/><path d="M12.281 35.2532C11.2733 34.2455 11.2733 32.6118 12.281 31.6041L15.9301 27.955C16.9378 26.9473 18.5715 26.9473 19.5792 27.955C20.5869 28.9626 20.5869 30.5964 19.5792 31.6041L15.9301 35.2532C14.9224 36.2609 13.2886 36.2609 12.281 35.2532Z" stroke="black"/><path d="M15.9299 38.9021C14.9222 37.8945 14.9222 36.2607 15.9299 35.253L19.579 31.6039C20.5867 30.5962 22.2204 30.5962 23.2281 31.6039C24.2358 32.6116 24.2358 34.2453 23.2281 35.253L19.579 38.9021C18.5713 39.9098 16.9376 39.9098 15.9299 38.9021Z" stroke="black"/><path d="M19.5791 42.5513C18.5714 41.5436 18.5714 39.9099 19.5791 38.9022L23.2282 35.2531C24.2358 34.2454 25.8696 34.2454 26.8773 35.2531C27.885 36.2607 27.885 37.8945 26.8773 38.9022L23.2282 42.5513C22.2205 43.559 20.5867 43.559 19.5791 42.5513Z" stroke="black"/></g></svg>
          </mds-col>
        </mds-row>
        <mds-row>
          <mds-col cols="12" cols-at-l="8">
            <mds-row>
              <mds-col cols="12" cols-at-m="4" v-for="(tier, tierIndex) in itemsData.programTiers" :key="tierIndex" :class="$style['become-a-partners__program-tier']">
                <mds-section border="primary" :title="tier.title" borderPosition="bottom" bold :size="4">
                  <p v-html="tier.description"></p>
                </mds-section>
              </mds-col>
            </mds-row>
          </mds-col>
        </mds-row>
        <br/>
        <mds-row>
          <mds-col cols="12" cols-at-l="8">
            <mds-section border="none" bold :size="3" :title="table.mainHeaderText" v-for="(table, tableIndex) in itemsData.tableData" :key="tableIndex">
              <mds-table>
                <mds-thead>
                  <mds-th
                    v-for="(header, index) in table.headerData"
                    :key="index"
                  >
                    {{ header.text }}
                  </mds-th>
                </mds-thead>
                <mds-tbody>
                  <mds-tr
                    v-for="(row, index) in table.rowData"
                    :key="index"
                  >
                    <mds-td
                      v-for="(header, i) in table.headerData"
                      :key="i"
                    >
                      <template v-if="header.fieldName === 'name'">
                        <strong>{{ row[header.fieldName] }}</strong>
                        <mds-button v-if="row.toolTip" :class="$style['info-icon']" variation="icon-only" size="small" icon="info-circle" type="button" @click="togglePopover(tableIndex, index)" :id="`glossary-trigger-${tableIndex}${index}`"></mds-button>
                        <mds-popover @mds-popover-dismissed="popoverDismissed()" v-if="row.toolTip" :triggered-by="`glossary-trigger-${tableIndex}${index}`" :visible="toggle[`${tableIndex}${index}`]" :position="['right-center']">
                          <item-description :description="row.toolTip" :class="$style[`${row[header.fieldName].replace(/\s+/g, '-').toLowerCase()}__glossary`]"></item-description>
                        </mds-popover>
                      </template>
                      <template v-else>
                        <template v-if="header.fieldName === 'basic'">
                          <span v-if="row.basic" :class="[$style['basic'], $style['donut']]"></span>
                          <span v-if="row.basicText"> {{ row.basicText }} </span>
                        </template>
                        <template v-else-if="header.fieldName === 'premium'">
                          <span v-if="row.premium" :class="[$style['premium'], $style['donut']]"></span>
                          <span v-if="row.premiumText"> {{ row.premiumText }} </span>
                        </template>
                        <template v-else>
                          <span v-if="row.elite" :class="[$style['elite'], $style['donut']]"></span>
                          <span v-if="row.eliteText"> {{ row.eliteText }} </span>
                        </template>
                      </template>
                    </mds-td>
                  </mds-tr>
                </mds-tbody>
              </mds-table>
            </mds-section>
          </mds-col>
        </mds-row>
      </template>

      <mds-row :class="$style['become-a-partners__footer-row']" v-if="itemsData.contact">
        <mds-col>
          <div :class="$style['become-a-partners__footer']">
            <item-description :description="itemsData.contact.displayText"></item-description>
            <mds-row align-horizontal="center" :class="$style['contact-section']">
              <mds-col :cols-at-m="2" :cols-at-l="1" >
                <mds-profile-image :class="$style['profile-photo']" :src="getImageUrl(itemsData.contact.image)" alt="Partner Program Head's Photo"></mds-profile-image>
              </mds-col>
              <mds-col :cols-at-m="6" :cols-at-l="3" :class="$style['contact']">
                <h2 :class="$style['name']">{{ itemsData.contact.name }}</h2>
                <p :class="$style['designation']">{{ itemsData.contact.designation }}</p>
                <a :href="itemsData.contact.link" target="_blank" :class="$style['linkedin-link']">LinkedIn</a>
              </mds-col>
            </mds-row>
          </div>
        </mds-col>
      </mds-row>
    </mds-layout-grid>
  </div>
</template>
<script>
import ItemDescription from './items/item-description.vue';
import { MdsButton } from '@mds/button';
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";
import { MdsTable, MdsThead, MdsTh, MdsTbody, MdsTr, MdsTd } from '@mds/data-table';
import MdsSection from '@mds/section';
import MdsPopover from '@mds/popover';
import MdsProfileImage from '@mds/profile-image';
import { HOME_URL, PARTNERS_FILE } from '../data/constants';
import axios from "axios";

export default {
  name: 'become-a-partner',
  components: {
    ItemDescription,
    MdsButton,
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MdsTable,
    MdsThead,
    MdsTh,
    MdsTbody,
    MdsTr,
    MdsTd,
    MdsSection,
    MdsPopover,
    MdsProfileImage
  },
  data() {
    return {
      HOME_URL,
      itemsData: null,
      toggle: {}
    };
  },
  computed: {

  },
  methods: {
    async fetchItemsData() {
      const path = this.$route.path.split('/').pop();
      const jsonFileResponse = await axios.get(PARTNERS_FILE);
      this.itemsData = jsonFileResponse.data.items?.find(item => item.path === path);
    },
    togglePopover(tableIndex, index) {
      this.$set(this.toggle, `${tableIndex}${index}`, !this.toggle[`${tableIndex}${index}`]);
    },
    getImageUrl(imgUrl) {
      return `/content/hidden-from-navigation/${imgUrl}`;
    },
    popoverDismissed() {
      Object.keys(this.toggle).forEach(v => this.toggle[v] = false) // To reset all popovers to false(closed)
    }
  },
  async created() {
    await this.fetchItemsData();
  }
}
</script>
<style lang="scss" module>
@import '@mds/typography';
@import '@mds/link';

.mds-popover {
  max-height: 450px;
  overflow: auto;
}

.become-a-partners {
  padding: $mds-space-4-x $mds-space-4-x 0;
  margin: auto;
  max-width: 1347px;

  &__overview-link {
    a {
      color: #006fba !important;
      border-color: #006fba !important;
    }
  }

  &__popover-header {
    margin-top: 0;
    margin-bottom: 5px;
  }

  &__title {
    @include mds-level-1-heading();

    color: $mds-text-color-primary;
    margin: 0 0 $mds-space-3-x;
  }

  &__program-tier {

    &:nth-child(1) .mds-section__header-container h2::before {
      color: #518428;
    }

    &:nth-child(2) .mds-section__header-container h2::before {
      color: #1f55a5;
    }

    &:nth-child(3) .mds-section__header-container h2::before {
      color: #ef7622;
    }

    .mds-section__header-container {
      h2 {
        text-indent: 8px;

        &::before {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 6px solid;
          border-radius: 100%;
          position: relative;
          left: -8px;
          top: -3px;
        }
      }
    }
  }

  &__back-btn {
    margin-bottom: $mds-space-8-x;
  }

  table tr > th:not(:first-child), table tr > td:not(:first-child) {
    text-align: center;
    width: 70px;

    @media screen and (min-width: $mds-breakpoint-s) {
      width: 130px;
    }

    .mds-th__inner {
      justify-content: center;
    }

    span:nth-child(2) {
      display: block;
      text-align: center;
    }
  }

  .info-icon {
    position: relative;
    top: 3px;
    left: 3px;
  }

  .donut {
    display: block;
    width: 20px;
    height: 20px;
    border: 6px solid;
    border-radius: 100%;
    margin: 0 auto;

    &.basic {
      border-color: $mds-color-dark-green-34;
    }

    &.premium {
      border-color: $mds-color-blue-38;
    }

    &.elite {
      border-color: $mds-color-orange-54;
    }
  }

  &__footer {
    text-align: center;
    padding: $mds-space-2-x;

    &-row {
      background-color: $mds-interactive-color-secondary-active;
    }

    & &-title {
      @include mds-level-1-heading();
      color: $mds-text-color-primary-on-dark;
      margin: $mds-space-1-x;
    }

    & &-text {
      @include mds-level-4-heading();
      color: $mds-text-color-primary-on-dark;

      &:before {
        content: none;
      }
    }

    .contact-section {
      margin-top: $mds-space-3-x;

      .mds-profile-image {
        width: 100px;
        height: 145px;
        border-radius: 6px;
      }

      .contact {
        margin-left: $mds-space-2-x;
        text-align: left;

        .name {
          color: $mds-text-color-primary-on-dark;
          text-align: left;
          margin-bottom: $mds-space-half-x;
          @include mds-level-4-heading($bold: true);
        }

        .designation {
          text-align: left;
          margin-bottom: $mds-space-half-x;
          color: $mds-text-color-primary-on-dark;
          @include mds-body-text-l()
        }

        .linkedin-link {
          text-align: left;
          margin-bottom: $mds-space-half-x;
          @include mds-link($on-dark: true);
          @include mds-body-text-l();
        }
      }
    }
  }
}
</style>
